import {createAction, props} from '@ngrx/store';
import {Clip} from '../../../services/api/clips/clip.model';

const category = '[GetClipByID]';

export const loadClipByID = createAction(
    `${category} Load Clip By ID`,
    props<{ id: string }>()
);

export const loadClipByIDSuccess = createAction(
    `${category} Load Clip By ID Success`,
    props<{ data: Clip }>()
);

export const loadClipByIDFailure = createAction(
    `${category} Load Clip By ID Failure`,
    props<{ error: any }>()
);

export const clearClipByIDState = createAction(
    `${category} Clear Clip By ID State`
);
